module.exports = __webpack_public_path__ + "media/images/strategic-partners/new/RingRx-8066a66ea75d851569405c675d2af638.png";